import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EtatService } from '../../Services/etat';
import { ParcResumeComponent } from '../../Composants/parc-resume/parc-resume';
import { ParcGrapheProductionComponent } from '../../Composants/parc-graphe-production/parc-graphe-production';
import { ParcProductionCumuleeComponent } from '../../Composants/parc-production-cumulee/parc-production-cumulee';
import { ParcInstallationsParTypesComponent } from '../../Composants/parc-installations-par-types/parc-installations-par-types';
import { ParcContactsComponent } from '../../Composants/parc-contacts/parc-contacts';
import { ParcListeParcsComponent } from '../../Composants/parc-liste-parcs/parc-liste-parcs';

@Component({
  selector: 'app-parc',
  imports: [CommonModule, ParcResumeComponent, ParcGrapheProductionComponent, ParcProductionCumuleeComponent, ParcInstallationsParTypesComponent, ParcContactsComponent, ParcListeParcsComponent],
  templateUrl: './parc.html',
  styleUrl: './parc.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Parc {
  private etat = inject(EtatService);
  parcs = this.etat.parcs;

  constructor() {
    if (!this.parcs().length) {
      void this.etat.chargerParcs();
    }
  }
}
